import { useEffect, useState } from "react";
import { AdminLayout } from "../../components/Layouts";
import { api, readUser, errMsg } from "../../lib/api";

export default function AdminReferralSettings() {
  const user = readUser();
  const [settings, setSettings] = useState(null);
  const [notice, setNotice] = useState({ ok: false, msg: "" });

  async function load() { const r = await api.get("/admin/settings"); setSettings(r.data); }
  useEffect(() => { load().catch(() => {}); }, []);

  async function save(e) {
    e.preventDefault();
    setNotice({ ok: false, msg: "" });
    try {
      const rates = settings.referral_rates.map(Number);
      await api.put("/admin/settings", { ...settings, referral_rates: rates });
      setNotice({ ok: true, msg: "Oranlar kaydedildi. Geçmiş kayıtlar değişmez; yeni aktivasyonlar yeni oranları kullanır." });
    } catch (e) { setNotice({ ok: false, msg: errMsg(e) }); }
  }
  function setRate(i, v) { const next = [...settings.referral_rates]; next[i] = v; setSettings({ ...settings, referral_rates: next }); }

  if (!settings) return <AdminLayout user={user} active="Referans Sistemi"><div className="empty-activity"><p>Yükleniyor…</p></div></AdminLayout>;

  return (
    <AdminLayout user={user} active="Referans Sistemi">
      <section className="admin-panel">
        <div className="admin-panel-title"><div><span className="eyebrow">4 SEVİYE UNİLEVEL</span><h2>Referans Komisyon Oranları</h2></div></div>
        {notice.msg && <div className={notice.ok ? "success" : "error"} data-testid="admin-ref-notice">{notice.msg}</div>}
        <form onSubmit={save} className="pkg-form">
          {[1, 2, 3, 4].map((l) => (
            <label key={l}>{l}. Seviye Komisyon (%)
              <input data-testid={`admin-ref-level-${l}`} type="number" step="0.1" value={settings.referral_rates[l - 1] ?? 0} onChange={(e) => setRate(l - 1, e.target.value)} />
            </label>
          ))}
          <button className="btn btn-accent" data-testid="admin-ref-save">Oranları Kaydet</button>
        </form>
      </section>
    </AdminLayout>
  );
}
